import { useQuery } from "@apollo/client/react";
import { Box } from "@mui/material";
import React, { useState } from "react";
import { CustomDialog } from "../../../../../components/customDialog/CustomDialog";
import DataGridGenerico from "../../../../../components/dataGrid/DataGridGenerico";
import { GET_INDICACION_INSUMO } from "../../../../../data/graphQL/queries/GestionAsistencial/getIndicacionInsumo";
import { useTabIndicationSaveIndicacionColumns } from "../../hooks/TabIndicacion/useTabIndicationSaveIndicacionColumns";
import { useTabIndicationAddIndicacionFields } from "../../hooks/TabIndicacion/useTabIndicationAddIndicacionFields";
import { useTabIndicationEditIndicacionOnSubmit } from "../../hooks/TabIndicacion/useTabIndicationEditIndicacionOnSubmit";
import { TabIndicacionFields } from "./TabIndicacionFields";

export function TabIndicationEditIndicacionDialog({
  open,
  handleCloseDialog,
  idEvaluacion,
  indicationSelected,
  refetch = true,
  refetchSolicitudes = true
}) {
  const { idIndicacion, fechaDesde, fechaHasta } = indicationSelected;

  const fechaDesdeOriginal = fechaDesde;

  const [formValues, setFormValues] = useState({
    fechaDesde,
    fechaHasta,
    insumo: { id: "", label: "", descripcion: "", idUnidad: "", unidad: "" },
    cantidad: "",
    unidad: "",
    observacion: ""
  });

  const handleChange = (name, value) => {
    setFormValues((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const columns = useTabIndicationSaveIndicacionColumns(null, true);

  const { firstRowfields, secondRowfields, thirdRowfields } =
  useTabIndicationAddIndicacionFields({ idEvaluacion, isEditing: true });

  const { data, loading } = useQuery(GET_INDICACION_INSUMO, {
    fetchPolicy: "no-cache",
    variables: { idIndicacion }
  });


  const { onSubmitSaveIndication, saveIndicationLoading } =
  useTabIndicationEditIndicacionOnSubmit({
    idEvaluacion,
    idIndicacion,
    formValues,
    insumos: data?.indicacionInsumo?.valorEsperado || [],
    handleCloseDialog,
    refetch,
    refetchSolicitudes,
    fechaDesdeOriginal
  });

  return (
    <CustomDialog
      title={"Editar indicación"}
      open={open}
      fullWidth
      maxWidth="md"
      onCancel={handleCloseDialog}
      cancelText="Cancelar"
      acceptText={"Guardar"}
      onAccept={onSubmitSaveIndication}
      acceptLoading={saveIndicationLoading}>
      
      <Box display="flex" flexDirection="column" gap={3}>
        <TabIndicacionFields
          firstRowfields={firstRowfields}
          secondRowfields={secondRowfields}
          thirdRowfields={thirdRowfields}
          formValues={formValues}
          handleChange={handleChange} />
        
        <DataGridGenerico
          columns={columns}
          rows={data?.indicacionInsumo?.valorEsperado}
          toolbar={false}
          loading={loading}
          hideFooter />
        
      </Box>
    </CustomDialog>);

}